import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad }) {
  const [newRecommend, setNewRecommend] = useState({
    first_name: "",
    last_name: "",
    job: "",
    address: "",
    tel: "",
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewRecommend((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "recommend/",
          newRecommend,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              המלצות : {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="first_name">שם פרטי</label>
                        <input
                          type="text"
                          name="first_name"
                          className="form-control"
                          id="first_name"
                          value={newRecommend.first_name}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="last_name">שם משפחה</label>
                        <input
                          type="text"
                          name="last_name"
                          className="form-control"
                          id="last_name"
                          value={newRecommend.last_name}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="job">תפקיד</label>
                        <input
                          type="text"
                          name="job"
                          className="form-control"
                          id="job"
                          value={newRecommend.job}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="tel">טלפון</label>
                        <input
                          type="text"
                          name="tel"
                          className="form-control"
                          id="tel"
                          value={newRecommend.tel}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="row w-75">
                    <Col>
                      <div className="form-group">
                        <label htmlFor="address">שם וכתובת מקום העבודה</label>
                        <input
                          type="text"
                          name="address"
                          className="form-control"
                          id="address"
                          value={newRecommend.address}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
